import { gql, useMutation } from '@apollo/client';
import {
  PrepareCheckCaptureMutation,
  PrepareCheckCaptureMutationVariables,
} from '@/types';

export const PREPARE_CHECK_CAPTURE_MUTATION = gql`
  mutation PrepareCheckCapture(
    $chatUUID: uuid!
    $deviceTracking: DeviceTrackingHasuraInput!
  ) {
    prepareCheckCapture(chat_id: $chatUUID, device_tracking: $deviceTracking) {
      alert_level
      alert_message
      misnap_license
      front_upload_url
      rear_upload_url
      front_s3_key
      rear_s3_key
    }
  }
`;

/**
 * Authenticates with Jack Henry and returns a MiSnap license + S3 pre-signed
 * upload URLs for the front and rear check images.
 *
 * @example
 * const [prepareCheckCapture, { loading }] = usePrepareCheckCapture();
 * prepareCheckCapture({
 *   variables: {
 *     chatUUID,
 *     deviceTracking: getCheckCaptureDeviceTracking(),
 *   },
 *   onCompleted: (data) => setCheckCapture(...),
 * });
 */
export const usePrepareCheckCapture = () =>
  useMutation<
    PrepareCheckCaptureMutation,
    PrepareCheckCaptureMutationVariables
  >(PREPARE_CHECK_CAPTURE_MUTATION);
